export default __webpack_public_path__ + "static/media/main1.507fb997.png";